import type { RecruitmentData } from '@metapic-apps/shared'

export const formatRecruitmentUtm = (utm: string): string => {
  try {
    const parsedUtm = JSON.parse(utm)
    if (parsedUtm !== null && typeof parsedUtm === 'object' && !Array.isArray(parsedUtm)) {
      return Object.entries(parsedUtm as Record<string, string>)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ')
    }
  } catch {
    // If parsing fails, fall back to the original string
  }
  return utm
}

export const getRecruitmentUtmLabel = (recruitment: {
  recruitmentData?: RecruitmentData | null
  recruitmentUtm?: string | null
}): string | null => {
  const campaign = recruitment.recruitmentData?.campaign
  if (campaign) {
    return `${campaign.advertiser.name}: ${campaign.name} (ID: ${campaign.id})`
  }
  return recruitment.recruitmentUtm != null
    ? formatRecruitmentUtm(recruitment.recruitmentUtm)
    : null
}
